import script from "./DetectorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DetectorPage.vue?vue&type=script&setup=true&lang=js"

import "./DetectorPage.vue?vue&type=style&index=0&id=f9915838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9915838"]])

export default __exports__